import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import isoWeek from 'dayjs/plugin/isoWeek';

import { REPORT_RANGE } from '@consts/reports';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(weekOfYear);
dayjs.extend(quarterOfYear);
dayjs.extend(isoWeek);
dayjs.tz.setDefault('America/New_York');

export enum DatePreset {
    LastSevenDays = 'last 7 days',
    LastThreeMonths = 'last 3 months',
    ThisMonth = 'this month',
    AllTime = 'all time',
}

export const datePresetFns = {
    [DatePreset.LastSevenDays]: () => ({
        startDate: dateFormat(dayjs().subtract(7, 'days').toString()),
        endDate: dateFormat(),
    }),
    [DatePreset.ThisMonth]: () => ({
        startDate: getMonthInfo(0).firstDay,
        endDate: dateFormat(),
    }),
    [DatePreset.LastThreeMonths]: () => ({
        startDate: getMonthInfo(3).firstDay,
        endDate: dateFormat(),
    }),
    [DatePreset.AllTime]: () => ({
        startDate: undefined,
        endDate: undefined,
    }),
};

export const getMonthInfo = (monthAway: number) => {
    const currentDate = dayjs();
    const newDate = currentDate.month(currentDate.get('month') - monthAway);
    const firstDay = dayjs().year(newDate.get('year')).month(newDate.get('month')).startOf('month');
    const lastDay = dayjs().year(newDate.get('year')).month(newDate.get('month')).endOf('month');
    return { firstDay: dateFormat(firstDay.toString()), lastDay: dateFormat(lastDay.toString()) };
};

export const parseDate = (date: string, format: REPORT_RANGE) => {
    switch (format) {
        case REPORT_RANGE.WEEKLY: {
            // Backend returns ISO week format: "YYYY-WNN" (e.g. "2024-W12")
            const [yearStr, weekStr] = date.split('-');
            const year = parseInt(yearStr);
            const week = parseInt(weekStr.replace(/^W/i, ''));
            return dayjs().year(year).isoWeek(week);
        }
        case REPORT_RANGE.QUARTERLY: {
            const [quarterYear, quarter] = date.split('-').map((item) => parseInt(item));
            return dayjs().year(quarterYear).quarter(quarter);
        }
        default:
            return dayjs(date);
    }
};

export const dateFormat = (date?: string) => {
    const dateDayjs = date ? dayjs(date) : dayjs();
    return dateDayjs.format('YYYY-MM-DD');
};

export const getPreviousMonth = (today: Date): Date => {
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth();

    const month = currentMonth === 0 ? 11 : currentMonth - 1;
    const year = currentMonth === 0 ? currentYear - 1 : currentYear;

    return new Date(year, month);
};
